import React from 'react'
import Logo from '../atoms/Logo';

export default ({display = true}) => {
    return (
        <div className={`loading-page ${display ? 'd-flex' : 'd-none'}`}>
            <div className='object'>
                <Logo />
                <div className="spinner-border" role="status">
                </div>
            </div>
        </div>
    )
}